export default __webpack_public_path__ + "static/media/logo-fidepol-512.5651b34e.png";